import React from "react";
import { Reveal } from "../shared/Reveal";

export default function Interlude({ children, variant = "" }) {
  return (
    <section className={`interlude ${variant}`}>
      <div className="wrap">
        <Reveal className="il" tag="blockquote">{children}</Reveal>
      </div>
    </section>
  );
}
